import React, { useEffect, useState } from "react";
import { IconButton, Tooltip } from "@mui/material";
import { Edit as IconEdit } from "@mui/icons-material";
import { withSnackbar } from "notistack";

import UiDialog from "components/Custom/UiDialog";
import RadioBtn from "components/Custom/RadioBtn";
import Btn from "components/Custom/Btn";
import Loader from "components/Custom/Loader";
import ExcelGrid from "components/Custom/ExcelGrid";
import TxtRow from "components/Custom/TxtRow";
import { NOTIFY } from "common/config";
import { COLORS } from "common/colors";
import { DEFAULTS } from "common/config";
import {
  LABELS,
  WARNINGS,
  TITLES,
  SUCCESS,
  ERRORS,
  SUB_TITLES,
} from "common/lables";
import { COMMON_JS } from "common/scripts";

import { MASTER_APIs } from "apihandlers/master";

const TSExpense = (props: any) => {
  const { setDashMenu } = props;

  const [loading, setLoading] = useState(true);
  const [isSubmit, setIsSubmit] = useState(false);
  const [rows, setRows] = useState<any>(null);
  const [manageDialog, setManageDialog] = useState(false);
  const [selectedRow, setSelectedRow] = useState<any>({});
  const [mandatoryResults, setMandatoryResults] = useState<any[]>([]);

  const columns = [
    {
      key: "slNo",
      name: LABELS.SL_NO,
      width: "5%",
      type: "number",
      align: "center",
      headerAlign: "center",
      editable: false,
      sortable: true,
      searchable: true,
    },
    {
      key: "expenseName",
      name: LABELS.EXPENSE_NAME,
      width: "25%",
      type: "text",
      align: "center",
      editable: false,
      sortable: true,
      searchable: true,
    },
    {
      key: "expenseCode",
      name: LABELS.EXPENSE_CODE,
      width: "15%",
      type: "text",
      align: "center",
      editable: false,
      sortable: true,
      searchable: true,
    },
    {
      key: "expenseDialCode",
      type: "text",
      name: LABELS.EXPENSE_DIAL_CODE,
      width: "15%",
      align: "center",
      editable: false,
      sortable: true,
      searchable: true,
    },
    {
      key: "modeOfExpense",
      type: "text",
      name: LABELS.MODE_OF_EXPENSE,
      width: "12%",
      align: "center",
      editable: false,
      sortable: true,
      searchable: true,
    },
    {
      key: "unitOfMeasurement",
      name: LABELS.UNIT_OF_MEASUREMENT,
      width: "13%",
      type: "text",
      align: "center",
      editable: false,
      sortable: true,
      searchable: true,
    },
    {
      key: "activeStatusText",
      name: LABELS.ACTIVE,
      width: "10%",
      type: "dropdown",
      filters: [
        { id: "yes", name: "Yes" },
        { id: "no", name: "No" },
      ],
      editable: false,
      sortable: true,
      searchable: true,
    },
    {
      key: "options",
      name: LABELS.OPTIONS,
      width: "5%",
      renderCell: (params) => (
        <div className="options">
          <Tooltip title={LABELS.EDIT} placement="bottom">
            <IconButton
              className="iconBtn"
              onClick={() => onEditRow(params.row)}
            >
              <IconEdit />
            </IconButton>
          </Tooltip>
        </div>
      ),
    },
  ];

  useEffect(() => {
    if (loading) {
      getRows();
    }
  }, [loading]);

  const getRows = async () => {
    try {
      const args = {
        pageNo: 1,
        pageLength: DEFAULTS.PAGE_LENGTH,
      };
      const res: any = await MASTER_APIs.getExpenses(args);
      const { status, response } = res;
      if (status === 200) {
        let list = response.records;
        for (let i = 0; i < response.records.length; i++) {
          list[i]["slNo"] = i + 1;
          if (list[i]["activeStatus"]) {
            list[i]["activeStatusText"] = "Yes";
          } else {
            list[i]["activeStatusText"] = "No";
          }
        }
        setRows(list);
        setLoading(false);
      }
    } catch (error) {
      console.error("getExpenses:", error);
    }
  };

  const onEditRow = (row: any) => {
    setSelectedRow(row);
    setManageDialog(true);
    console.log("selectedRow:", selectedRow);
  };

  const manageExpense = () => {
    const expenseName = (
      document.getElementById("expenseName") as HTMLInputElement
    ).value.trim();
    const expenseCode = (
      document.getElementById("expenseCode") as HTMLInputElement
    ).value.trim();
    const expenseDialCode = (
      document.getElementById("expenseDialCode") as HTMLInputElement
    ).value.trim();
    const unitOfMeasurement = (
      document.getElementById("unitOfMeasurement") as HTMLInputElement
    ).value.trim();
    const mode = document.querySelector(
      'input[name="modeOfExpense"]:checked'
    ) as HTMLInputElement;
    const modeOfExpense = mode ? mode.value : "";
    const active = document.querySelector(
      'input[name="activeStatus"]:checked'
    ) as HTMLInputElement;
    const selectBtnValue = active ? active.value : "";

    // Validations
    let errors = [];
    if (expenseName === "") {
      errors.push({
        id: "expenseName",
        msg:
          "<span class='bold'>" +
          LABELS.EXPENSE_NAME +
          "</span> " +
          WARNINGS.IS_A_REQUIRED_FIELD,
      });
    }
    if (!selectBtnValue) {
      errors.push({
        id: "selectBtnValue",
        msg:
          "<span class='bold'>" +
          LABELS.ACTIVE_STATUS +
          "</span> " +
          WARNINGS.IS_A_REQUIRED_FIELD,
      });
    }
    setMandatoryResults(errors);
    if (errors.length > 0) {
      COMMON_JS.showNotify(
        props,
        NOTIFY.WARNING,
        WARNINGS.PLEASE_CHECK_FORM_ERRORS
      );
      return;
    }

    const args = {
      id: selectedRow.id || -1,
      expenseName,
      expenseCode,
      expenseDialCode,
      modeOfExpense: modeOfExpense,
      unitOfMeasurement,
      activeStatus: selectBtnValue.toString(),
    };
    setIsSubmit(true);
    MASTER_APIs.manageExpense(args).then((res) => {
      setIsSubmit(false);
      if (res.status === 200) {
        COMMON_JS.showNotify(props, NOTIFY.SUCCESS, SUCCESS.RECORD_SUCCESS);
        setSelectedRow({});
        setManageDialog(false);
        reloadGrid();
      } else {
        COMMON_JS.showNotify(props, NOTIFY.ERROR, ERRORS.RECORD_FAILED);
      }
    });
  };

  const reloadGrid = () => {
    setRows(null);
    getRows();
  };

  const onAdd = () => {
    setSelectedRow({});
    setManageDialog(true);
  };

  console.log("Page: TS Expense:");

  return (
    <React.Fragment>
      <div className="pageInfo">
        <ul className="breadcrumbs">
          <li onClick={() => setDashMenu("")}>{LABELS.HOME}</li>
          <li className="dim">{" / "}</li>
          <li onClick={() => setDashMenu(LABELS.HOME)}>{LABELS.MASTERS} </li>
          <li className="dim">{" / "}</li>
          <li className="active">{TITLES.TS_EXPENSE}</li>
        </ul>
        <h4>{TITLES.TS_EXPENSE}</h4>
        <p>{SUB_TITLES.TS_EXPENSE}</p>
      </div>

      <div className="grid excelGridWrapper">
        {rows ? (
          <ExcelGrid
            id={LABELS.TS_EXPENSE}
            height={window.innerHeight * 0.8}
            cols={columns}
            rows={rows}
            exportOption={true}
            newRowOption={false}
            exportName={LABELS.TS_EXPENSE}
            onReload={reloadGrid}
            onAdd={onAdd}
          />
        ) : (
          <div className="flexRowCenter">
            <Loader />
          </div>
        )}
      </div>

      {manageDialog && (
        <UiDialog
          title={
            selectedRow.id
              ? "Edit " + LABELS.TS_EXPENSE + ": " + selectedRow.id
              : "Add New " + LABELS.TS_EXPENSE
          }
          open={true}
          size={"sm"}
          onClose={() => {
            setManageDialog(false);
            setMandatoryResults([]);
          }}
        >
          <div className="formGroup red">
            <TxtRow
              id={"expenseName"}
              type={"text"}
              label={LABELS.EXPENSE_NAME}
              required={true}
              defaultValue={selectedRow.expenseName}
              disabled={isSubmit}
            />
          </div>
          <div className="formGroup">
            <TxtRow
              id={"expenseCode"}
              type={"text"}
              label={LABELS.EXPENSE_CODE}
              defaultValue={selectedRow.expenseCode}
              disabled={isSubmit}
            />
          </div>
          <div className="formGroup">
            <TxtRow
              id={"expenseDialCode"}
              type={"text"}
              label={LABELS.EXPENSE_DIAL_CODE}
              defaultValue={selectedRow.expenseDialCode}
              disabled={isSubmit}
            />
          </div>
          <div className="formGroup ">
            <label>{LABELS.MODE_OF_EXPENSE}</label>
            <RadioBtn
              list={[
                {
                  id: "CASH",
                  label: LABELS.CASH,
                  value: LABELS.CASH,
                  checked: selectedRow.id
                    ? selectedRow.modeOfExpense === "CASH"
                    : false,
                  disabled: false,
                },
                {
                  id: "BANK",
                  label: LABELS.BANK,
                  value: LABELS.BANK,
                  checked: selectedRow.id
                    ? selectedRow.modeOfExpense === "BANK"
                    : false,
                  disabled: false,
                },
                {
                  id: "UPI",
                  label: LABELS.UPI,
                  value: LABELS.UPI,
                  checked: selectedRow.id
                    ? selectedRow.modeOfExpense === "UPI"
                    : false,
                  disabled: false,
                },
                {
                  id: "CARD",
                  label: LABELS.CARD,
                  value: LABELS.CARD,
                  checked: selectedRow.id
                    ? selectedRow.modeOfExpense === "CARD"
                    : false,
                  disabled: false,
                },
                {
                  id: "NONE",
                  label: LABELS.NONE,
                  value: LABELS.NONE,
                  checked: selectedRow.id
                    ? selectedRow.modeOfExpense === "NONE"
                    : true,
                  disabled: false,
                },
              ]}
              row={true}
              name={"modeOfExpense"}
              disabled={isSubmit}
            />
          </div>
          <div className="formGroup">
            <TxtRow
              id={"unitOfMeasurement"}
              type={"text"}
              label={LABELS.UNIT_OF_MEASUREMENT}
              defaultValue={selectedRow.id ? selectedRow.unitOfMeasurement : ""}
              disabled={isSubmit}
            />
          </div>
          <div className="formGroup">
            <label className="red">
              {LABELS.ACTIVE_STATUS} {<span>*</span>}
            </label>
            <RadioBtn
              list={[
                {
                  id: "true",
                  value: "true",
                  label: LABELS.ACTIVE,
                  checked: selectedRow.id
                    ? selectedRow.activeStatus === true
                    : true,
                  disabled: false,
                },
                {
                  id: "false",
                  value: "false",
                  label: LABELS.INACTIVE,
                  checked: selectedRow.id
                    ? selectedRow.activeStatus === false
                    : false,
                  disabled: false,
                },
              ]}
              row={true}
              name={"activeStatus"}
              disabled={isSubmit}
            />
          </div>
          {/* mandatoryResults */}
          {mandatoryResults.length > 0 && (
            <div className="mandatoryBox">
              <ul>
                {mandatoryResults.map((m) => {
                  return (
                    <li>
                      <span dangerouslySetInnerHTML={{ __html: m.msg }} />
                    </li>
                  );
                })}
              </ul>
            </div>
          )}
          <div className="formGroup submitBtnWrapper">
            <div className="flexbtnjustify">
              <Btn
                text={LABELS.CANCEL}
                loading={isSubmit}
                bgColor={COLORS.RELOAD_EXPORT}
                color={COLORS.RELOAD_EXPORT_TEXT}
                onClick={() => {
                  setManageDialog(false);
                  setMandatoryResults([]);
                }}
              />
              <Btn
                text={LABELS.SAVE}
                loading={isSubmit}
                onClick={manageExpense}
                bgColor={COLORS.SAVE_GREEN}
              />
            </div>
          </div>
        </UiDialog>
      )}
    </React.Fragment>
  );
};

export default withSnackbar(TSExpense);
